export default __webpack_public_path__ + "static/media/HHJ-logo.7bee3bff.png";